<div class="content-container">
  <h1 class="center">404</h1>
  <p class="center">
    Die Seite konnte leider nicht gefunden werden
  </p>
  <p class="center">
    <a class="back-to-home" routerLink="/">Zur Startseite</a>
  </p>
</div>